import React from 'react';
import AlignBoxInput from 'app/components/common/AlignBoxInput';
import InputOblong from 'app/components/common/InputOblong/InputOblong';
import { InputText } from '@encarpkg/design';
import InputAddress from 'app/components/common/InputAddress/InputAddress';

function ExportInfoForm({
	exportStatus,
	exportName,
	exportZipCode,
	exportAddress,
	exportTel,
	onChangeExportStatus,
	onChangeExportName,
	onChangeExportTel,
	onClickExportAddress,
	onBlurExportName,
	onBlurExportTel,
	exportNameInvalidMessage,
	exportAddressInvalidMessage,
	exportTelInvalidMessage,
	exportNameRef,
	exportTelRef,
}) {
	return (
		<>
			<h3
				className="fs17 fcBlack4"
				style={{ marginTop: '40px' }}
			>
				수출사업을 하고 계신가요?
			</h3>
			<AlignBoxInput
				type="float"
				style={{ marginTop: '20px' }}
			>
				<InputOblong
					key="수출사업_예"
					type="radio"
					id="exportSelectYes"
					name="exportSelect"
					label="예"
					value="Y"
					target={exportStatus}
					onChange={onChangeExportStatus}
					classArray={['mypage_select']}
				/>
				<InputOblong
					key="수출사업_아니오"
					type="radio"
					id="exportSelectNo"
					name="exportSelect"
					label="아니오"
					value="N"
					target={exportStatus}
					onChange={onChangeExportStatus}
					style={{ marginLeft: '30px' }}
					classArray={['mypage_select']}
				/>
			</AlignBoxInput>
			{exportStatus === 'Y' && (
				<>
					<InputText.V2
						label="수출업체 상호명"
						type="text"
						id="exportName"
						name="exportName"
						value={exportName}
						onChange={onChangeExportName}
						validation={!!exportNameInvalidMessage}
						validationText={exportNameInvalidMessage}
						onBlur={onBlurExportName}
						useLabel
						required
						ref={exportNameRef}
						labelStyle={{ marginTop: '30px' }}
					/>
					<AlignBoxInput
						type="block"
						validation={!!exportAddressInvalidMessage}
						validationText={exportAddressInvalidMessage}
					>
						<InputAddress
							isV2
							label="수출업체 주소"
							postCdId="exportPostCd"
							postCdName="exportPostCd"
							postCdValue={exportZipCode}
							addressId="exportAddress"
							addressName="exportAddress"
							addressValue={exportAddress}
							detailId="exportDetail"
							detailName="exportDetail"
							onClick={onClickExportAddress}
							validation={!!exportAddressInvalidMessage}
							required
							noDetail
						/>
					</AlignBoxInput>
					<InputText.V2
						label="수출업체 전화번호"
						type="tel"
						id="exportTel"
						name="exportTel"
						value={exportTel}
						placeholder="'-'제외하고 숫자만 입력"
						onChange={onChangeExportTel}
						onBlur={onBlurExportTel}
						validation={!!exportTelInvalidMessage}
						validationText={exportTelInvalidMessage}
						useLabel
						required
						ref={exportTelRef}
						labelStyle={{ marginTop: '30px' }}
					/>
					<p
						className="fs12 fcBlack3"
						style={{ marginTop: '10px' }}
					>
						평생번호(0502, 0504, 0505, 0506) 및 대표번호 (1599,1566 등) 는 050안심번호로 연결이 불가합니다. 대표번호는 지역번호와 함께
						입력해주세요.
					</p>
					<p
						className="fs12 fcBlack3"
						style={{ marginTop: '10px' }}
					>
						엔카의 수출차량 매입광고를 이용하시려면 <b>수출업체 정보를 필수로 입력</b>하셔야 합니다.
						<br />
						회원님이 <b>직접 입력하신 매매 상사/조합 정보가 잘못되어 발생하는 문제에 대해 엔카는 책임을 지지 않습니다.</b>
					</p>
				</>
			)}
		</>
	);
}

export default ExportInfoForm;
